function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Arrow Link Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "arrow-link-Icon/Global/Arrow/Textlink",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.6187184,5.83128157 L20.6187184,11.8312816 C20.9604272,12.1729903 20.9604272,12.7270097 20.6187184,13.0687184 L14.6187184,19.0687184 C14.2770097,19.4104272 13.7229903,19.4104272 13.3812816,19.0687184 C13.0395728,18.7270097 13.0395728,18.1729903 13.3812816,17.8312816 L17.838,13.374 L4,13.375 C3.51675084,13.375 3.125,12.9832492 3.125,12.5 C3.125,12.0167508 3.51675084,11.625 4,11.625 L17.936,11.624 L13.3812816,7.06871843 C13.0395728,6.72700968 13.0395728,6.17299032 13.3812816,5.83128157 C13.7229903,5.48957281 14.2770097,5.48957281 14.6187184,5.83128157 Z",
  id: "arrow-link-Combined-Shape",
  fill: "currentcolor",
  fillRule: "nonzero"
}));

var SvgArrowLink = function SvgArrowLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-link.9de96b0a.svg";
export { ForwardRef as ReactComponent };